import {NgModule} from "@angular/core"
import {LoginPageComponent} from "app/login/view/LoginPageComponent"
import {MaterialModule} from "app/common/material/MaterialModule"
import {RouterModule} from "@angular/router"
import {ReactiveFormsModule} from "@angular/forms"
import {CommonModule} from "@angular/common"

@NgModule({
    declarations: [
        LoginPageComponent
    ],
    entryComponents: [
        LoginPageComponent
    ],
    imports: [
        MaterialModule,
        RouterModule,
        ReactiveFormsModule,
        CommonModule
    ]
})
export class LoginModule {

}
